import React from "react";
import { Link } from "react-router-dom";
import "./HomePage.css";

const navItems = [
  { name: "Home", path: "/" },
  { name: "Managers", path: "/managers" },
  { name: "Seasons", path: "/seasons" },
  { name: "League Settings", path: "/league-settings" },
];

const Navbar = () => (
  <header className="header">
    <nav className="nav-bar">
      {navItems.map(({ name, path }) => (
        <Link key={name} to={path} className="nav-link">
          {name}
        </Link>
      ))}
    </nav>
  </header>
);

export default Navbar;
